'use client';

import React, { useEffect, useState } from 'react';
import { classnames } from 'helpers/utils/classnames';
import BackToTopIcon from 'icons/back-to-top';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > window.innerHeight);
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={classnames(
        'fixed bottom-2 right-2 z-50 transition-all duration-300 md:bottom-8 md:right-8',
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0',
      )}
      aria-label="Back to top"
    >
      <BackToTopIcon className="h-16 w-16 md:h-20 md:w-20" />
    </button>
  );
};

export default BackToTop;
